import "antd/dist/antd.css";
import axios from "axios";
import { get } from "lodash";
import { Fragment } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AuthenticatedRoute from "./components/Auth/AuthenticatedRoute";
import Sidebar from "./components/Header/Sidebar";
import Casestudymanagement from "./pages/CasestudyManagement/Casestudymanagement";
import Login from "./pages/Login/Login";
import ServiceManagement from "./pages/ServiceManagement/ServiceManagement";
import FilterCasestudyLinkedManagement from "./pages/FilterCasestudyLinkedManagement/FilterCasestudyLinkedManagement";
import { getAuthToken } from "./utils/auth";

const App = () => {
  axios.interceptors.request.use(
    (config: any) => {
      const token = getAuthToken();
      if (token) {
        config.headers.authorization = token;
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (config: any) => {
      return config;
    },
    (error: any) => {
      if (get(error, "response.status") === 403) {
        localStorage.clear();
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );

  return (
    <Router>
      <Fragment>
        <Routes>
          <Route
            path="/login"
            element={
              <>
                <Login />
              </>
            }
          ></Route>
          <Route
            path="/"
            element={
              <>
                <Sidebar />
                <AuthenticatedRoute />
              </>
            }
          >
            <Route path="/" element={<Casestudymanagement />}></Route>
            <Route
              path="/servicemanagement"
              element={<ServiceManagement />}
            ></Route>
            <Route
              path="/linkedcasestudymanagement"
              element={<FilterCasestudyLinkedManagement />}
            ></Route>
            {/* <Route path="/usermanagement" element={<Usermanagement />}></Route>
            <Route
              path="/restaurantmanagement"
              element={<Restaurantmanagement />}
            ></Route> */}
          </Route>
        </Routes>
      </Fragment>
    </Router>
  );
};

export default App;
